import * as zod from 'zod'
import { toTypedSchema } from '@vee-validate/zod'

export const reportStatusOverrideValidationSchema = toTypedSchema(
    zod.object({
        status: zod.number(),
        comment: zod.string().min(3, 'formInputs.validation.requiredMinCharacters'),
    }),
)
